import { Dispatch, SetStateAction } from 'react';

import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import { LimitsDetails } from '@clients/accountsClient';
import EditLimitsForm from '@pages/limits/EditLimitsForm';

export type EditLimitsDialogProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    refetch?: () => void;
    limits: LimitsDetails;
};

const EditLimitsDialog = ({
    open,
    setOpen,
    limits,
    refetch,
}: EditLimitsDialogProps) => {
    const handleCloseDialog = () => {
        setOpen(false);
    };

    return (
        <PDialog
            open={open}
            onClose={handleCloseDialog}
            data-testid="dialog-edit-limits"
            maxWidth="sm"
            fullWidth
            dialogTitle={
                <FormattedMessage
                    id="EditLimitsDialog.title"
                    defaultMessage="Edit account limits"
                />
            }
            dialogSubtitle={
                <FormattedMessage
                    id="EditLimitsDialog.desc"
                    defaultMessage="You can edit your details by changing the input fields below then clicking save."
                />
            }>
            <EditLimitsForm
                limits={limits}
                setOpen={setOpen}
                refetch={refetch}
            />
        </PDialog>
    );
};

export default EditLimitsDialog;
